import React, { useState } from "react";
import styled from "styled-components";
import { fabric } from "fabric";

const CANVAS_SIZE = 512;

const Container = styled.div`
  width: auto;
  height: 100%;
  display: flex;
`;

const MenuIconContainer = styled.div`
  width: 60px;
  background: #232323;
`;
const MenuOptionContainer = styled.div`
  width: 200px;
  background: #fff;
`;

const Button = styled.a`
  display: block;
  padding: 8px 16px;
  border-bottom: 1px solid #444;
  cursor: pointer;
  color: ${props => (props.active ? "#232323" : "#aaa")};
  background: ${props => (props.active ? "#999" : "transparent")};
  i {
    vertical-align: middle;
  }
`;
const Option = styled.div``;
const OptionItem = styled.div`
  display: block;
  padding: 16px;
  border-bottom: 1px solid #ccc;
`;

const MENU_TYPES = {
  text: "text",
  image: "image",
  shape: "shape",
  smiley: "smiley"
};

const TextOptions = ({ addText }) => {
  const addTitle = e => {
    e.preventDefault();
    const text = new fabric.IText("Add Title", {
      fontFamily: "arial",
      left: 100,
      top: 100,
      fontSize: 32
    });
    addText(text);
  };
  const addSubTitle = e => {
    e.preventDefault();
    const text = new fabric.IText("Add Sub Title", {
      fontFamily: "arial",
      left: 100,
      top: 120,
      fontSize: 22
    });
    addText(text);
  };
  const addParagraph = e => {
    e.preventDefault();
    const text = new fabric.IText("Add Paragraph", {
      fontFamily: "arial",
      left: 100,
      top: 150,
      fontSize: 16
    });
    addText(text);
  };
  return (
    <Option>
      <OptionItem onClick={e => addTitle(e)}>
        <h2>Add Title</h2>
      </OptionItem>
      <OptionItem onClick={e => addSubTitle(e)}>
        <h3>Add Sub Title</h3>
      </OptionItem>
      <OptionItem onClick={e => addParagraph(e)}>
        <p>Add Paragraph</p>
      </OptionItem>
    </Option>
  );
};
const ShapeOptions = ({ addShape }) => {
  const addSquare = e => {
    e.preventDefault();
    const rectangle = new fabric.Rect({
      width: 100,
      height: 100,
      strokeWidth: "",
      stroke: "",
      fill: "#4099ff"
    });
    addShape(rectangle);
  };
  const addCircle = e => {
    e.preventDefault();
    const circle = new fabric.Circle({
      radius: 50,
      left: 10,
      top: 10,
      strokeWidth: "",
      stroke: "",
      fill: "#4099ff"
    });
    addShape(circle);
  };
  const addTriangle = e => {
    e.preventDefault();
    const triangle = new fabric.Triangle({
      width: 100,
      height: 100,
      fill: "#4099ff",
      left: 50,
      top: 50
    });
    addShape(triangle);
  };
  return (
    <Option>
      <OptionItem onClick={e => addSquare(e)}>Square</OptionItem>
      <OptionItem onClick={e => addCircle(e)}>Circle</OptionItem>
      <OptionItem onClick={e => addTriangle(e)}>Triangle</OptionItem>
    </Option>
  );
};

const ImageOptions = ({ addImage }) => {
  const uploadImage = e => {
    e.preventDefault(e);
    fabric.Image.fromURL(
      "https://res.cloudinary.com/sivadass/image/upload/v1493620046/dummy-products/cauliflower.jpg",
      image => {
        // if image size is greater than canvas, reduce the size by half
        if (image.width > CANVAS_SIZE) {
          image.scale(0.5);
        }
        addImage(image);
      },
      { crossOrigin: "anonymous" }
    );
  };
  const searchImage = e => {
    e.preventDefault();
    fabric.Image.fromURL(
      "https://res.cloudinary.com/sivadass/image/upload/v1493620045/dummy-products/tomato.jpg",
      image => {
        // if image size is greater than canvas, reduce the size by half
        if (image.width > CANVAS_SIZE) {
          image.scale(0.33);
        }
        addImage(image);
      },
      { crossOrigin: "anonymous" }
    );
  };
  return (
    <Option>
      <OptionItem onClick={e => uploadImage(e)}>Upload</OptionItem>
      <OptionItem onClick={e => searchImage(e)}>Search</OptionItem>
    </Option>
  );
};

const SmileyOptions = () => {
  return (
    <Option>
      <OptionItem>Coming soon!</OptionItem>
    </Option>
  );
};

const Menu = ({ addNew, exportAsPNG }) => {
  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");

  const handleMenuSelection = (event, menu) => {
    event.preventDefault();
    if (activeMenu === menu) {
      setOpen(false);
      setActiveMenu("");
    } else {
      setOpen(true);
      setActiveMenu(menu);
    }
  };

  const addImage = e => {
    e.preventDefault();
    fabric.Image.fromURL(
      "https://res.cloudinary.com/sivadass/image/upload/v1493620046/dummy-products/cauliflower.jpg",
      image => {
        // if image size is greater than canvas, reduce the size by half
        if (image.width > CANVAS_SIZE) {
          image.scale(0.5);
        }
        addNew(image);
      },
      { crossOrigin: "anonymous" }
    );
  };
  const exportImage = e => {
    e.preventDefault();
    exportAsPNG();
  };
  return (
    <Container>
      <MenuIconContainer>
        <Button
          onClick={e => handleMenuSelection(e, MENU_TYPES.text)}
          active={activeMenu === MENU_TYPES.text}
        >
          <i className="material-icons">text_fields</i>
        </Button>
        <Button
          onClick={e => handleMenuSelection(e, MENU_TYPES.image)}
          active={activeMenu === MENU_TYPES.image}
        >
          <i className="material-icons">image</i>
        </Button>
        <Button
          onClick={e => handleMenuSelection(e, MENU_TYPES.shape)}
          active={activeMenu === MENU_TYPES.shape}
        >
          <i className="material-icons">star</i>
        </Button>
        <Button
          onClick={e => handleMenuSelection(e, MENU_TYPES.smiley)}
          active={activeMenu === MENU_TYPES.smiley}
        >
          <i className="material-icons">insert_emoticon</i>
        </Button>
      </MenuIconContainer>
      {open && (
        <MenuOptionContainer>
          {activeMenu === MENU_TYPES.text && <TextOptions addText={addNew} />}
          {activeMenu === MENU_TYPES.shape && (
            <ShapeOptions addShape={addNew} />
          )}
          {activeMenu === MENU_TYPES.image && (
            <ImageOptions addImage={addNew} />
          )}
          {activeMenu === MENU_TYPES.smiley && (
            <SmileyOptions addSmiley={addNew} />
          )}
        </MenuOptionContainer>
      )}
    </Container>
  );
};

export default Menu;
